export default __webpack_public_path__ + "static/media/CL01.1.b4289b4a.mp3";